<template>
	<div class="container-modal form-modal">
        <div v-if="$resize && $mq.above(601)" class="content-icon forgot" @mouseover="logoAnim">
			<lottie class="bird-logo active" :options="defaultOptionsLogo" :height="112" :width="112" v-on:animCreated="handleAnimationLogo"/>
        </div>
		
		<div class="container-holder">
			<div class="info-content">
				<div class="header-modal">
					<div class="title">{{ $t('register.title_step_3') }}</div>
				</div>
				<div class="container-content-modal" v-if='loaded'>
					<div class="form-section-register">
						<div class="input-login-group-tbf w-tbf-100">
							<div class="subscription-box custom" v-for="subPackage,index in packagesList.filter(el => el.package_bundle == 'Single')" v-bind:class="{active: subPackage.package_id == packageActive.package_id, inactive: packageActive.package_id && subPackage.package_id != packageActive.package_id, first: index == 0, 'error-selected': errorSelectPlan}" @click="selectPlan(subPackage)">
								<div class="top-section">
									<p class="first">
										{{ subPackage.package_name }}
									</p>
									<div class="second">
										<div class="price">
											{{ user.newPrices.find((el) => el.package_id == subPackage.package_id) ? user.newPrices.find((el) => el.package_id == subPackage.package_id).price + ' EUr' : subPackage.price_in_euro + ' EUR' }}
										</div>
										<span class="old-price" v-if="user.newPrices.find((el) => el.package_id == subPackage.package_id)">{{ subPackage.price_in_euro }} EUR / luna</span>
										<span v-else>{{ $t('subscription.monthly') }}</span>
									</div>
								</div>
								<div class="third-section">
									<div class="box mobile" v-for="textFe in subPackage.includes">
										<span>{{ textFe }}</span>
									</div>
								</div>
							</div>
						</div>	

						<div class="input-login-group-tbf w-tbf-100">
							<p class="get-quote" v-html="$t('subscription.get_quote')"></p>
						</div>

					</div>
					<div class="submit-form">
						<button class="btn-tbf blue center" @click="openConfirmation">
							<div class="loader"></div>
							<div class="text">{{$t('register.next_step')}}</div>
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="submodal-container active" v-if="subModalShow">
			<div class="overlay-submodal"></div>

			<div class="submodal-tbf active">
				<div class="container-content-modal">
					<div class="header-modal">
						<div class="title">{{ $t('subscription.confirm_subscription_title') }}</div>
						<div class="actions">
							<div class="btn-default-tbf close-btn" @click="closeModalConfirmation"><icon-close class="icon-close" /></div>
						</div>
					</div>
					<div class="summary">
						<div class="summary-box">
							{{ $t('subscription.confirm_subscription_summary', { package: packageActive.package_name, price: 
								user.newPrices.find((el) => el.package_id == packageActive.package_id) ? (user.newPrices.find((el) => el.package_id == packageActive.package_id).price + ' EUR') : (packageActive.price_in_euro + ' EUR')}) }}
						</div>

						<div class="submit-form">
							<button id="buttonNextStep" class="btn-tbf blue center" @click="goNextStep">
								<div class="loader"></div>
								<div class="text">{{ $t('subscription.confirm') }}</div>
							</button>
						</div>
					</div>
				</div>


			</div>
		</div>
	</div>
</template>


<script>
	import Lottie from 'vue-lottie';
	import * as animationDataLogo from '../../assets/animations/tbfdigital_logo.json';

	import IconClose from '../Icons/Close'
	import IconPeople from '../Icons/User'
	import IconInvoice from '../Icons/Invoice'
	import IconSettings from '../Icons/Settings'

	export default {
		data(){
			return {
				defaultOptionsLogo: {
					animationData: animationDataLogo.default,
					autoplay: false,
					loop: false,
				},
				finished: true,
				packageActive: {},
				packagesList: {},
				subModalShow: false,
				loaded: false,
				errorSelectPlan: false
			}
		},
		props:{
			user: Object
		},
		components: {
			IconClose,
			IconPeople,
			IconInvoice,
			IconSettings,
			Lottie
		},
		async mounted() {
			await this.getPackages()
		},
		methods: {
			async getPackages(){
				await axios.get('packages').then(({data}) => {
					this.packagesList = data.data;

					if(this.$route.query.token){
						this.packageActive = this.packagesList.find(el => el.token == this.$route.query.token)
						this.user.packageActive = this.packageActive
					}else{
						this.packageActive = {};
					}

					this.loaded = true;
					this.logoAnim();
				}).catch(error => {
					if(error.response) {
						if(error.response.status == 500) {
							alert(this.$t('error.500'))
						}
					}
				});
			},
			openConfirmation(){
				//temporar
				this.errorSelectPlan = false

				if(this.packageActive.package_id){
					this.subModalShow = true;
				}else{
					this.errorSelectPlan = true
				}
			},
			goNextStep(e){
				var buttonName = 'buttonNextStep'
                var btnSubmit = document.getElementById(buttonName);
                var btnSubmitLoader = document.querySelector(`#${buttonName} .loader`)
                var btnSubmitText = document.querySelector(`#${buttonName} .text`)

                btnSubmit.disabled = true
                btnSubmit.classList.add('loading')
                btnSubmitLoader.classList.add('onProgress')
                btnSubmitText.innerHTML = this.$t('btn-submit.loading')

                btnSubmitLoader.classList.add('finish')
                setTimeout(()=>{
                	btnSubmitText.innerHTML = this.$t('btn-submit.success')
                	btnSubmit.classList.add('completed')
                	btnSubmitLoader.classList.remove('onProgress', 'finish')
                	btnSubmit.classList.remove('loading')
                	setTimeout(()=>{
                		btnSubmit.classList.remove('completed')
                		btnSubmitText.innerHTML = this.$t('subscription.confirm')
                		this.$emit("next_step", {user: this.user, next_step: 4});
                	}, 1000)
                }, 300)
			},

			closeModal(){
				this.$router.push("/login");
			},
			closeModalConfirmation() {
				this.subModalShow = false;
			},
			selectPlan(packageItem){
				this.errorSelectPlan = false
				this.packageActive = packageItem;
				this.user.packageActive = packageItem;
			},
			displayModal(){
				this.subModalShow = true;
			},
			handleAnimationLogo(anim){
				this.anim_logo = anim;
				this.anim_logo.setSpeed(1);
			},
			logoAnim(){
				if(this.finished){
					this.finished = false;
					this.anim_logo.play();
					setTimeout(() => {
						this.anim_logo.stop();
						this.finished = true;
					}, 5000);
				}
			}
		}
	}
</script>